import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FloatingPopupAnimationCallbackRegistry {
  private registry = new Map<string, (() => void)[]>();

  public add(id: string, cb: () => void) {
    if (!this.registry.has(id)) {
      this.registry.set(id, []);
    }

    this.registry.get(id)!.push(cb);
  }

  public execute(id: string) {
    const list = this.registry.get(id);
    if (!list || !list.length) {
      return;
    }

    list.forEach(cb => cb());
    this.registry.delete(id);
  }

  public has(id: string) {
    return this.registry.has(id);
  }

  public delete(id: string) {
    this.registry.delete(id);
  }
}
